// extracted by mini-css-extract-plugin
export var container = "SessionCard-module--container--3DgQF";
export var imageWrap = "SessionCard-module--imageWrap--4LzBq";
export var textWrap = "SessionCard-module--textWrap--2epyI";